export enum ComparisonPoolType {
  BASE = -1,
  INCLUSION = -2,
  EXCLUSION = -3,
}
